import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import { updateRouteTitles } from '@enums/route-enum';
import messages from './translations';

const DEFAULT_LANG = 'en-AU';

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    percent: {
      style: 'percent',
    },
    decimal: {
      style: 'decimal',
    },
  },
  'en-AU': {
    currency: {
      style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    percent: {
      style: 'percent',
    },
    decimal: {
      style: 'decimal',
    },
  },
  'zh-TW': {
    currency: {
      style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    percent: {
      style: 'percent',
    },
    decimal: {
      style: 'decimal',
    },
  },
  'zh-CN': {
    currency: {
      style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    percent: {
      style: 'percent',
    },
    decimal: {
      style: 'decimal',
    },
  },
};

const dateTimeFormats = {
  'en-AU': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'zh-TW': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'zh-CN': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
};

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  fallbackLocale: DEFAULT_LANG,
  messages,
  numberFormats,
  dateTimeFormats,
});

const loadedLanguages = [DEFAULT_LANG]; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  updateRouteTitles(i18n);

  return lang;
}

export function loadLanguageAsync(lang) {
  if (!lang) {
    return Promise.resolve(lang);
  }

  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackMode: "lazy", webpackChunkName: "lang-[request]" */ `./translations/${lang}`).then((msgs) => {
        i18n.setLocaleMessage(lang, msgs.default);
        loadedLanguages.push(lang);

        return setI18nLanguage(lang);
      });
    }

    return Promise.resolve(setI18nLanguage(lang));
  }

  return Promise.resolve(lang);
}
